import React, { Fragment } from 'react';
import i18n from 'utils/translate';
import { formatPrice } from 'utils/common';
import { PAYMENT_TYPE_BIANNUAL, PAYMENT_TYPE_MONTHLY, PAYMENT_TYPE_QUARTERLY } from './constants';

export const paymentDetails = (zahlungsweise, quote) => {
  let label = '';
  let price = '';

  switch (zahlungsweise) {
    case PAYMENT_TYPE_BIANNUAL:
      label = `${i18n('halbjährlich')}: `;
      price = formatPrice(quote.paymentVariants[PAYMENT_TYPE_BIANNUAL], quote.currency);
      break;
    case PAYMENT_TYPE_QUARTERLY:
      label = `${i18n('vierteljährlich')}: `;
      price = formatPrice(quote.paymentVariants[PAYMENT_TYPE_QUARTERLY], quote.currency);
      break;
    case PAYMENT_TYPE_MONTHLY:
      label = `${i18n('monatlich')}: `;
      price = formatPrice(quote.paymentVariants[PAYMENT_TYPE_MONTHLY], quote.currency);
      break;
    default:
      return;
  }
  return (
    <p>
      <small>
        {label} {<Fragment>{price}</Fragment>}
      </small>
    </p>
  );
};

export const calculateEndDate = startDate => {
  return startDate ? startDate.clone().add(1, 'months').startOf('month').add(1, 'year').format('DD.MM.YYYY') : null;
};

export const getGroupByKey = (key, groups) => {
  const obj = groups.find(el => el.key === key);
  return !!obj
    ? `Klasse ${obj.klasse} | ${
        obj.fachgruppe ? `Fachgruppe ${obj.fachgruppe} | ${obj.beschreibung}` : obj.beschreibung
      }`
    : i18n('unbekannt');
};

export const getGroupsByKeys = (keys, groups) => {
  return keys ? keys.map(key => getGroupByKey(key, groups)) : [];
};
